import {
  SUPPORTED_LOCALES_ARR,
  SUPPORTED_LOCALES_OBJ,
  type SupportedLocale,
} from '@zep-us/i18n';
import { useRouter } from 'next/router';

export const useLocale = () => {
  const { locale, locales } = useRouter();
  return {
    locale: (locale ?? SUPPORTED_LOCALES_OBJ.ko) as SupportedLocale,
    locales: (locales ?? SUPPORTED_LOCALES_ARR) as SupportedLocale[],
  };
};
